import transitionEnd from 'dom-helpers/transitionEnd';
export default function transitionEndListener(element, handler) {
  var remove = transitionEnd(element, function (e) {
    if (e.target === element) {
      remove();
      handler(e);
    }
  });
}